import { Component, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { ProductionOrderService, ProductionOrderData } from '../../services/production-order.service';
import { Subscription } from 'rxjs';
import { toast, MaterializeAction } from 'angular2-materialize';
import { SortablejsOptions } from 'angular-sortablejs';
import { CustomerSupplierService } from '../../services/customer-supplier.service';

@Component({
  selector: 'app-odp-priority',
  templateUrl: './odp-priority.component.html',
  styleUrls: ['./odp-priority.component.css']
})
export class OdpPriorityComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  loading: boolean[] = [false];
  get loaded(): boolean { return !this.loading.includes(false); }

  get statuses(){ return Object.keys(this.data.statusObjects).map(key => this.data.statusObjects[key]); }
  odpsByStatus: any = {};
  odp: any;

  undo: any;

  sub: Subscription;

  sortablejsOptions: SortablejsOptions = {
    disabled: true,
    group: 'odps',
    onUpdate: ({from}: any) => {
      let statusName = this.data.statusObjects[from.id].name;
      this.odpsByStatus[statusName].map(({id$}, index) => {
        this.service.putProductionOrder({priority: index}, id$);
      });
    },
    onAdd: ({from, to, item}: any) => {
      let fromName = this.data.statusObjects[from.id].name;
      let toName = this.data.statusObjects[to.id].name;
      if(to.id >= 'key98')  this.undo = {from: from.id, to: to.id, item: item.id};
      this.service.putProductionOrder({status: to.id}, item.id);
      this.odpsByStatus[fromName].map(({id$}, index) => {
        this.service.putProductionOrder({priority: index}, id$);
      });
      this.odpsByStatus[toName].map(({id$}, index) => {
        this.service.putProductionOrder({priority: index}, id$);
      });
    }
  }

  constructor(
    private service: ProductionOrderService,
    private data: ProductionOrderData,
    private customerService: CustomerSupplierService,
		private permissionService: PermissionService,
    private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) this.router.navigate(['/']);
        else{
          this.sortablejsOptions.disabled = !this.permission.updateAction;
        } this.allowed = true;
    });

    this.sub = this.service.getProductionOrders({lessStatus: 'key98', onEmpty: ()=>{
      toast('No hay órdenes de producción pendientes.', 3000);
      this.loading[0] = true;
    } }).subscribe(odps => {
      this.odpsByStatus = this.statuses.reduce((acc, cur) => { acc[cur.name] = []; return acc; }, {});
      odps.sort(({priority:p1=Infinity}, {priority: p2=Infinity}) => p1 > p2 ? 1 : -1).map(odp => {
        let sub = this.customerService.getCustomerSupplier(odp.customer.id).subscribe(c => { sub.unsubscribe(); odp.customer.name = c.name; })
        this.odpsByStatus[odp.status].push(odp);
      });
      this.loading[0] = true;
    })

  }

  ngOnInit() {
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }

  onUndo(){
    this.service.putProductionOrder({status: this.undo.from}, this.undo.item);
    this.undo = undefined;
  }
  
  /////////////////////////////////////////////////////////////////////////////////////////////////SHOW
  modalActionsShow = new EventEmitter<string|MaterializeAction>();
  modalParamsShow = [{dismissible: true}];

  openModalShow(odp) {
    this.odp = odp;
    this.modalActionsShow.emit({ action: 'modal', params: ['open'] });
  }
  closeModalShow() {
    this.modalActionsShow.emit({ action: 'modal', params: ['close'] });
  }
  /////////////////////////////////////////////////////////////////////////////////////////////////SHOW

}
